<template>
  <div id="app">
    <router-view :style="{width: screenWidth + 'px', height: screenHeight + 'px'}"/>
  </div>
</template>
<script>

import WatermarkIndex from "@/component/watermark.vue";

export default {
  name: "APP",
  components: {WatermarkIndex},
  data() {
    return {
      screenWidth: document.documentElement.clientWidth, // 屏幕宽度
      screenHeight: document.documentElement.clientHeight, // 屏幕高度
    }
  },
  created() {
    this.screenWidth = document.documentElement.clientWidth;
    this.screenHeight = document.documentElement.clientHeight;
    this.$store.dispatch("setScreenWidth", this.screenWidth);
    this.$store.dispatch("setScreenHeight", this.screenHeight);
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      sessionStorage.removeItem('store')
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    window.addEventListener('resize', () => {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = document.documentElement.clientHeight;
      this.$store.dispatch("setScreenWidth", this.screenWidth);
      this.$store.dispatch("setScreenHeight", this.screenHeight);
    })
  },
  async mounted() {
    this.screenWidth = document.documentElement.clientWidth;
    this.screenHeight = document.documentElement.clientHeight;
    this.$store.dispatch("setScreenWidth", this.screenWidth);
    this.$store.dispatch("setScreenHeight", this.screenHeight);
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
      sessionStorage.removeItem('store')
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    window.addEventListener('resize', () => {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = document.documentElement.clientHeight;
      this.$store.dispatch("setScreenWidth", this.screenWidth);
      this.$store.dispatch("setScreenHeight", this.screenHeight);
    })
  },
  methods: {}
}
</script>
<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.el-dialog__body {
  padding: 10px;
}

body, html {
  background-color: #F0F2F4;
  width: 100%;
  height: 100%;
  font-size: 15px;
  color: #555555;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>
